import { T } from "./translation-keys";
import { BetType } from "../models";

export const BetTypeNames = {
  [BetType.Single]: T.SINGLE,
  [BetType.Express]: T.EXPRESS,
  [BetType.System]: T.SYSTEM,
};
